import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import LogsService from "services/logs";
import {
  ACOES_LOG,
  alteracoesDoLog,
  rotuloCampo,
  valorLog,
} from "utils/logRotulos";

/** Histórico de alterações de um registro (quem, quando, o quê). */
export default function HistoricoRegistro({ open, area, id, onClose }) {
  const [logs, setLogs] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (!open || !id) return;
    setLogs(null);
    setErro("");
    LogsService.historico(area, id)
      .then(setLogs)
      .catch((e) => setErro(e?.error || "Erro ao carregar o histórico."));
  }, [open, area, id]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{ zIndex: 10001 }}
    >
      <DialogTitle>Histórico de alterações</DialogTitle>
      <DialogContent>
        {erro && <Alert severity="error">{erro}</Alert>}
        {logs === null && !erro && (
          <Typography variant="body2">Carregando...</Typography>
        )}
        {logs?.length === 0 && (
          <Typography variant="body2">Nenhuma alteração registrada.</Typography>
        )}
        {logs?.map((log) => (
          <Box
            key={log._id}
            mb={2}
            pb={1}
            sx={{ borderBottom: "1px solid #eee" }}
          >
            <Typography variant="body2">
              <b>{new Date(log.createdAt).toLocaleString("pt-BR")}</b> ·{" "}
              {log.user?.name || log.user?.email || "?"} ·{" "}
              {ACOES_LOG[log.action] || log.action}
            </Typography>
            {alteracoesDoLog(log).length > 0 ? (
              alteracoesDoLog(log).map((a) => (
                <Typography
                  key={a.campo}
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  {rotuloCampo(a.campo)}:{" "}
                  {log.action === "edita"
                    ? `${valorLog(a.campo, a.de)} → ${valorLog(
                        a.campo,
                        a.para
                      )}`
                    : valorLog(a.campo, a.para ?? a.de)}
                </Typography>
              ))
            ) : log.changedData ? (
              <Typography variant="caption" color="text.secondary">
                (registro antigo, sem detalhe de/para)
              </Typography>
            ) : null}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
